import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { Dashboard } from './../layouts'
import {
    ActionDelete,
    ActionNewButton,
    ActionUpdateButton,
    BaseTable,
    BaseTableActions
} from './../components'
import { pathJoin } from './../utils/helpers'

const columns = [
    {
        name: 'job_name',
        title: 'Нэр'
    },
    {
        name: 'end_date',
        title: 'Дуусах хугацаа'
    },
    {
        name: 'created',
        title: 'Үүсгэсэн'
    },
    {
        name: 'updated',
        title: 'Шинэчилсэн'
    },
    {
        getCellValue: ({ id }) => <ActionUpdateButton path={pathJoin('jobs', id)} />
    }
]

const dateColumns = [
    'created', 'updated'
]

export default class Jobs extends Component {
    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    fetchData = () => {
        return this.table.current.fetchData()
    }

    render() {
        return (
            <Dashboard title="Мэдээ">
                <BaseTableActions>
                    <Grid item>
                        <ActionNewButton path="/jobs/new" />
                    </Grid>
                    <Grid item>
                        <ActionDelete
                            path="/jobs/mass/destroy"
                            onDelete={this.fetchData}
                        />
                    </Grid>
                </BaseTableActions>
                <BaseTable
                    path="jobs"
                    columns={columns}
                    dateColumns={dateColumns}
                    innerRef={this.table}
                />
            </Dashboard>
        )
    }
}